import { render, staticRenderFns } from "./MainMenuSidebar.vue?vue&type=template&id=166363f8&scoped=true"
import script from "./MainMenuSidebar.vue?vue&type=script&lang=js"
export * from "./MainMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./MainMenuSidebar.vue?vue&type=style&index=0&id=166363f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166363f8",
  null
  
)

export default component.exports